import '../DigitalCases.css'
import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const PlataformaDeECommerce = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesDigital = [
    {
      id: 2,
      title: 'plataformaDeECommerce_page.relatedCases.items.gestaoDePrecos.title',
      description:
        'plataformaDeECommerce_page.relatedCases.items.gestaoDePrecos.description',
      url: 'plataforma-de-gestao-de-precos',
    },
    {
      id: 3,
      title: 'plataformaDeECommerce_page.relatedCases.items.exportacao.title',
      description: 'plataformaDeECommerce_page.relatedCases.items.exportacao.description',
      url: 'plataforma-de-exportacao',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('plataformaDeECommerce_page.relatedCases.cta')

    trackCtaClick({
      cta_name: 'digital_case_related_case_click',
      cta_location: 'digital_case',
      page_name: 'plataforma_de_e_commerce',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('plataformaDeECommerce_page.header.title')}</h2>
        </div>
        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase2.png"
            alt={t('plataformaDeECommerce_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">
            {t('plataformaDeECommerce_page.sections.challenge.title')}
          </h3>
          <ul>
            <li>{t('plataformaDeECommerce_page.sections.challenge.items.item1')}</li>
            <li>{t('plataformaDeECommerce_page.sections.challenge.items.item2')}</li>
            <li>{t('plataformaDeECommerce_page.sections.challenge.items.item3')}</li>
            <li>{t('plataformaDeECommerce_page.sections.challenge.items.item4')}</li>
            <li>{t('plataformaDeECommerce_page.sections.challenge.items.item5')}</li>
            <li>{t('plataformaDeECommerce_page.sections.challenge.items.item6')}</li>
          </ul>

          <hr />

          <h3>{t('plataformaDeECommerce_page.sections.result.title')}</h3>
          <ul>
            <li>{t('plataformaDeECommerce_page.sections.result.items.item1')}</li>
            <li>{t('plataformaDeECommerce_page.sections.result.items.item2')}</li>
            <li>{t('plataformaDeECommerce_page.sections.result.items.item3')}</li>
            <li>{t('plataformaDeECommerce_page.sections.result.items.item4')}</li>
            <li>{t('plataformaDeECommerce_page.sections.result.items.item5')}</li>
          </ul>

          {/*
          <div className="DataHashtag">
            <button>Data Engineering</button>
            <button>GEN IA</button>
            <button>Full Stack development</button>
            <button>UX</button>
          </div>
          */}
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('plataformaDeECommerce_page.relatedCases.title')}</h2>
        <span className="subtitle">
          {t('plataformaDeECommerce_page.relatedCases.subtitle')}
        </span>

        <Pagination data={casesDigital} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('plataformaDeECommerce_page.relatedCases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default PlataformaDeECommerce
